<template>
  <div class="customField pb-4">
    <div
      class="v-label mb-2"
      :class="{
        'v-label--is-disabled': !editFlag,
        'theme--light': !this.$vuetify.theme.dark,
        'theme--dark': this.$vuetify.theme.dark,
      }"
    >
      2. What are the names of the academic degrees you have earned?
      <span class="error--text">*</span>
    </div>

    <v-row
      v-for="(degree, degreeKey) in degrees"
      :key="`degree${degreeKey}`"
      align="baseline"
      class="pb-4"
    >
      <v-col
        cols="12"
        sm="3"
        class="py-1"
      >
        Degree {{ degreeKey + 1 }}
      </v-col>
      <v-col
        cols="5"
        sm="3"
        class="py-1"
      >
        <v-select
          v-model="degree.degree"
          label="Degree"
          :items="degreesList"
          item-value="key"
          item-text="value"
          :loading="listLoading"
          :rules="rules.degree_list"
          :disabled="!editFlag"
        />
      </v-col>
      <v-col
        cols="6"
        sm="5"
        class="py-1"
      >
        <v-select
          v-model="degree.major"
          label="Major"
          :items="degreeMajorList"
          item-value="key"
          item-text="value"
          :loading="processLoading"
          :rules="rules.degree_list"
          :disabled="!editFlag"
        />
      </v-col>
      <v-col
        cols="1"
      >
        <v-btn
          icon
          x-small
          :disabled="!editFlag || degrees.length <= 1"
          @click="removeDegree(degreeKey)"
        >
          <v-icon
            small
          >
            close
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-btn
      v-show="editFlag"
      color="primary"
      block
      :disabled="!editFlag"
      @click="addNewDegree"
    >
      Add new degree
    </v-btn>
  </div>
</template>

<script>
import demographicsApi from '@/api/commons/demographics';

export default {
  name: 'Question2',

  props: {
    editFlag: {
      type: Boolean,
      default: false,
    },

    listLoading: {
      type: Boolean,
      default: false,
    },

    degreesList: {
      type: Array,
      default: null,
    },

    degrees: {
      type: Array,
      default: null,
    },

    rules: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    processLoading: false,
    degreeMajorList: [],
  }),

  mounted() {
    this.getDegreeMajorList();
  },

  methods: {
    async getDegreeMajorList() {
      try {
        this.processLoading = true;
        this.degreeMajorList = await demographicsApi.getDegreeMajorTypes();
      } catch (err) {
        console.log(err);
        this.$toast.error(err.msg);
      } finally {
        this.processLoading = false;
      }
    },

    addNewDegree() {
      const addResult = [...this.degrees, { degree: null, major: null, other: null }];
      this.$emit('update:degrees', addResult);
    },

    removeDegree(index) {
      const removeResult = this.degrees.filter((el, key) => key !== index);
      this.$emit('update:degrees', removeResult);
    },
  },
};
</script>
